<div *ngIf="showBlock" class="d-flex justify-content-center align-items-center overlay" [@showHide]="isLoading ? 'show' : 'hide'" (@showHide.done)="onAnimationEventDone($event)">
  <div class="spinner-border align-middle" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>
